import './cookiePolicy.html.twig';
import './cookiePolicy.css';

export default function() {
  const el = document.querySelector('.cookie-policy');

  if (!el) {
    return;
  }
  function handleStorage() {
    if (localStorage.getItem('cookie') === 'accepted') {
      el.style.display = 'none';
    } else {
      el.style.display = 'block';
    }
  }
  el.querySelector('.cookie-policy__cta').addEventListener('click', () => {
    localStorage.setItem('cookie', 'accepted');
    handleStorage();
  });
  try {
    if ('localStorage' in window && window.localStorage !== null) {
      handleStorage();
    }
  } catch (error) {
    console.error(error);
  }
}
